import {SUPPORTS_SYMBOL} from "./constructor";

export const SUPPORTS_SYMBOL_SEARCH = SUPPORTS_SYMBOL && "search" in Symbol;
